import { Button, Dropdown, Label } from '@heroui/react'
import { Icon, type IconName } from '../ui/icons'
import { useStaffText } from '../ui/StaffText'

export interface MoreItem {
  label: string
  icon: IconName
  onClick: () => void
  danger?: boolean
  disabled?: boolean
}

/** A «⋯» button holding the actions used now and then (HeroUI's Dropdown). up opens it above the button. */
export function MoreMenu({ items, up = false }: { items: MoreItem[]; up?: boolean }) {
  const { say } = useStaffText()
  const menu = (
    <Dropdown.Menu
      disabledKeys={items.flatMap((item, i) => (item.disabled ? [String(i)] : []))}
      onAction={(key) => items[Number(key)]?.onClick()}
    >
      {items.map((item, i) => (
        <Dropdown.Item key={item.label} id={String(i)} textValue={item.label} variant={item.danger ? 'danger' : 'default'}>
          <Icon name={item.icon} size={16} />
          <Label>{item.label}</Label>
        </Dropdown.Item>
      ))}
    </Dropdown.Menu>
  )
  return (
    <Dropdown>
      <Button isIconOnly variant="ghost" size="sm" aria-label={say('admin.publish.more')}>
        <Icon name="more" size={18} />
      </Button>
      {up ? <Dropdown.Popover placement="top end">{menu}</Dropdown.Popover> : <Dropdown.Popover placement="bottom end">{menu}</Dropdown.Popover>}
    </Dropdown>
  )
}
